import React, { useContext } from 'react';
import {
    CTAConfiguration,
    KontentStringValue,
    CTALocation,
} from '../../../types/KontentProps';
import { PageMetadataContext } from '../../templates/PageMetaDataContext';
import OnPageSupportSearch from './OnPageSupportSearch';
import { graphql } from 'gatsby';

export interface OnPageSupportProps extends CTAConfiguration {
    cta_label: KontentStringValue;
    headline: KontentStringValue;
    hint_text: KontentStringValue;
    search_term_subheadline: KontentStringValue;
    search_results_page: CTALocation;
    kontentItemId?: string;
}

const OnPageSupportSearchContainer: React.FC<OnPageSupportProps> = ({
    ...props
}) => {
    const pageMetadata = useContext(PageMetadataContext);

    return (
        <OnPageSupportSearch
            {...props}
            preferredLanguage={pageMetadata?.preferredLanguage}
        />
    );
};

export default OnPageSupportSearchContainer;

export const fragmentOnPageSupportSearch = graphql`
    fragment OnPageSupportSearch on kontent_item_component___on_page_support_search {
        elements {
            cta_label {
                value
            }
            headline {
                value
            }
            hint_text {
                value
            }
            search_results_page {
                value {
                    ... on kontent_item_layout___master_page {
                        elements {
                            slug {
                                url
                            }
                        }
                    }
                }
            }
            search_term_subheadline {
                value
            }
        }
    }
`;
